import React from "react";
import Typography from "@mui/material/Typography";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

// CSS styling
const useStyles = makeStyles({
  link: {
    marginTop: 10,
    marginBottom: 20,
  },
});

// Renders dashboard link for page navigation
function DashboardLink() {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <React.Fragment>
      {/* Link */}
      <Link
        className={classes.link}
        component="button"
        onClick={() => navigate("/")}
      >
        <Typography variant="subtitle2" gutterBottom noWrap>
          Dashboard
        </Typography>
      </Link>
      {/* Arrow icon */}
      <KeyboardArrowRightIcon style={{ position: "relative", top: "8px" }} />
    </React.Fragment>
  );
}

export default DashboardLink;
